import InstructorEditorVM from './instructor-editor-vm';
import GuestLecturerEditorVM from './guest-lecturer-editor-vm';
import TeachingAssistantEditorVM from './teaching-assistant-editor-vm';
export default {
  init : function() {
    console.log('Kadenze.CourseInstructorEditor initialization function called');

    var current_user_data = $('#current_user_json').val();
    var instructors_data = $('#instructors_json').val();
    var guest_lecturers_data = $('#guest_lecturers_json').val();
    var tas_data = $('#tas_json').val();
    var staff_data = $('#staff_json').val();
    var supporters_data = $('#supporters_json').val();
    var graduates_data = $('#graduates_json').val();

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true
    };

    ko.applyBindingsWithValidation(new InstructorEditorVM([instructors_data, current_user_data]), document.getElementById('instructors'), validationOptions);
    ko.applyBindingsWithValidation(new GuestLecturerEditorVM([guest_lecturers_data, current_user_data]), document.getElementById('guest_lecturers'), validationOptions);
    ko.applyBindingsWithValidation(new TeachingAssistantEditorVM([tas_data, current_user_data]), document.getElementById('tas'), validationOptions);
    ko.applyBindingsWithValidation(new TeachingAssistantEditorVM([staff_data, current_user_data]), document.getElementById('staff'), validationOptions);
    ko.applyBindingsWithValidation(new TeachingAssistantEditorVM([supporters_data, current_user_data]), document.getElementById('supporters'), validationOptions);
    ko.applyBindingsWithValidation(new TeachingAssistantEditorVM([graduates_data, current_user_data]), document.getElementById('graduates'), validationOptions);
  }
};

